/**
 * Safely parse a URL string. Accepts either absolute URLs
 * (`https://globalcomix.com/c/foo`) or relative paths (`/c/foo`) by
 * resolving against the current origin. Returns null when the input is
 * empty or malformed so callers can fall back to the raw string instead
 * of crashing the page.
 */
export function safeParseUrl(url: string | null | undefined): URL | null {
  if (!url) return null;
  try {
    return new URL(url, window.location.origin);
  } catch {
    return null;
  }
}

/**
 * Convenience helper for the common case of extracting a pathname from a
 * URL-like string. Falls back to the raw input when parsing fails so
 * downstream code (e.g. `react-router` `navigate`) still receives a path.
 */
export function toPathname(url: string | null | undefined): string {
  return safeParseUrl(url)?.pathname ?? url ?? "";
}
